import React from "react";
import styled from "@emotion/styled";

import {
  Badge,
  Grid,
  Avatar,
  Typography,
  Collapse,
  Alert,
} from "@mui/material";

import useAuth from "../../hooks/useAuth";
import { Link } from "react-router-dom";
import { SubscriptionStatus } from "../../types/subscription";

const Footer = styled.div`
  background-color: ${(props) =>
    props.theme.sidebar.footer.background} !important;
  padding: ${(props) => props.theme.spacing(2.75)}
    ${(props) => props.theme.spacing(4)};
  border-right: 1px solid rgba(0, 0, 0, 0.12);
`;

const FooterText = styled(Typography)`
  color: ${(props) => props.theme.sidebar.footer.color};
`;

const FooterSubText = styled(Typography)`
  color: ${(props) => props.theme.sidebar.footer.color};
  font-size: 0.7rem;
  display: block;
  padding: 1px;
`;

const FooterBadge = styled(Badge)`
  margin-right: ${(props) => props.theme.spacing(1)};
  span {
    background-color: ${(props) =>
      props.theme.sidebar.footer.online.background};
    border: 1.5px solid ${(props) => props.theme.palette.common.white};
    height: 12px;
    width: 12px;
    border-radius: 50%;
  }
`;

const SidebarFooter: React.FC = ({ ...rest }) => {
  const { currentUser, associationSubscription, trialActive } = useAuth();

  const associationId = currentUser?.activeAssociation.id;

  const subStatus = associationSubscription?.status ?? null;

  const noPaidSub =
    !associationSubscription || subStatus !== SubscriptionStatus.ACTIVE;

  const trialHasEnded =
    associationSubscription?.trialEnd &&
    new Date(associationSubscription.trialEnd) < new Date();

  const showTrial =
    subStatus === SubscriptionStatus.TRIALING && Boolean(trialActive);

  const trialExpired =
    subStatus === SubscriptionStatus.EXPIRED && trialHasEnded;

  return (
    <>
      <Collapse in={noPaidSub}>
        <Link
          to={`/associations/invoices/${associationId}`}
          style={{ textDecoration: "none" }}
        >
          <Alert
            severity={showTrial ? "info" : "warning"}
            sx={{ borderRadius: 0, mb: 4 }}
          >
            {showTrial
              ? "Käytössä on kokeiluversio. Aloita tilaus käyttääksesi kaikkia ominaisuuksia."
              : trialExpired
              ? "Kokeilujakso on päättynyt. Aloittamalla tilauksen saat ominaisuudet jälleen käyttöösi. "
              : "Tiekunnalla ei ole voimassa olevaa tilausta. Aloita tilaus käyttääksesi kaikkia ominaisuuksia."}
          </Alert>
        </Link>
      </Collapse>
      <Footer {...rest}>
        <Grid container spacing={2}>
          <Grid item>
            <FooterBadge
              overlap="circular"
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              variant="dot"
            >
              {!!currentUser && (
                <Avatar
                  alt={currentUser.displayName}
                  src={currentUser.avatar}
                />
              )}
              {/* Demo data */}
              {!currentUser && (
                <Avatar
                  alt="Lucy Lavender"
                  src="/static/img/avatars/avatar-1.jpg"
                />
              )}
            </FooterBadge>
          </Grid>
          <Grid item>
            {!!currentUser && (
              <FooterText variant="body2">
                {currentUser.firstName + " " + currentUser.lastName}
              </FooterText>
            )}
            {/* Demo data */}
            {!currentUser && (
              <FooterText variant="body2">Lucy Lavender</FooterText>
            )}
            <FooterSubText variant="caption">{currentUser?.role}</FooterSubText>
          </Grid>
        </Grid>
      </Footer>
    </>
  );
};

export default SidebarFooter;
